import React, { useState, useEffect } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import Dropdown from 'react-bootstrap/Dropdown';
import moment from 'moment';
import './TimeRangeSelector.css';

type TimeRangeSelectorProps = {
    selectedLiveOption: string;
    liveOptions: string[];
    changeLiveOption: (value: string) => void;
    changeCustomTimeRange: (starttime: string, endtime: string) => void;
    resetVisualisation?: () => void;
};

const TimeRangeSelector = ({
    selectedLiveOption,
    liveOptions,
    changeLiveOption,
    changeCustomTimeRange,
    resetVisualisation,
 }: TimeRangeSelectorProps) => {
    const [selected, setSelected] = useState('');
    const [isLiveDropdownOpen, setIsLiveDropdownOpen] = useState(false);


    const handleLiveSelect = (value: string) => {
        setIsLiveDropdownOpen(false);
        changeLiveOption?.(value);
        resetVisualisation?.();
    };

    const handleDatetimerangeUpdate = (start: any, end: any) => {
        changeCustomTimeRange?.(
            moment.utc(start).format(),
            moment.utc(end).format()
        );
        resetVisualisation?.();
    };

    useEffect(() => {
        setSelected(selectedLiveOption);
    }, [selectedLiveOption])

    return (
        <div>
            <div className="time-range-selector d-flex">
                {/* Live Dropdown - opens on hover */}
                <div
                    onMouseEnter={() => setIsLiveDropdownOpen(true)}
                    onMouseLeave={() => setIsLiveDropdownOpen(false)}
                >
                    <Dropdown show={isLiveDropdownOpen} drop="up" onSelect={handleLiveSelect}>
                        <Dropdown.Toggle
                            as='div'
                            className={`time-range-button no-caret left ${liveOptions.includes(selected) ? 'live-selected' : ''}`}
                            id="dropdown-live"
                        >
                            Live: {liveOptions.includes(selected) ? selected : 'Select'}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {liveOptions.map(option => (
                                <Dropdown.Item key={option} eventKey={option}>
                                    {option}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                {/* Custom Button */}
                <DateRangePicker
                    onCallback={handleDatetimerangeUpdate}
                    initialSettings={{
                        timePicker: true,
                        autoApply: true,
                        ranges: {
                            'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')]
                        },
                        alwaysShowCalendars: true,
                        maxDate: moment(),
                        startDate: moment().subtract(1, 'days').add(1, 'minutes'),
                        endDate: moment(),
                        showCustomRangeLabel: true,
                        dateLimit: { days: 1 },
                        opens: "center",
                        drops: "up",
                        locale: { format: "DD/MM/YYYY" }
                    }}
                >
                    <button
                        className={`time-range-button right ${liveOptions.includes(selected) ? '' : 'custom-selected'}`}
                    >
                        Historic
                    </button>
                </DateRangePicker>
            </div>

        </div>
    );
};

export default TimeRangeSelector;
